// extracted by mini-css-extract-plugin
module.exports = {"cursorTooltip":"styles_cursorTooltip__t38lT","fadeInOut":"styles_fadeInOut__xqTTv","loader":"styles_loader__0IS8x"};